exports.components = {
  "component---src-pages-auth-callback-js": () => import("./../../../src/pages/auth/callback.js" /* webpackChunkName: "component---src-pages-auth-callback-js" */),
  "component---src-templates-index-js": () => import("./../../../src/templates/index.js" /* webpackChunkName: "component---src-templates-index-js" */)
}

